/****************************************************************************
* Article list
****************************************************************************/

function fnArticleList( i, oSection ) {

	/**
	* Element
	*/
	var oSection					= $( oSection ),
		oArticle					= $( 'article.archive-post', oSection ),
		oVerticalText				= $( 'aside.vertical-title', oSection );

	/***************
	* After filter change (via Ajax)
	* Plugin: Search & Filter Pro
	***************/
	$( document ).on( 'sf:ajaxfinish', '.searchandfilter', function() {

		// Re-init lazy loading | https://github.com/ApoorvSaxena/lozad.js
		fnLazyLoading();

		// Re-init in-view detection | https://github.com/zeusdeux/isInViewport
		fnInViewDetect();

		// Hide vertical text
		oVerticalText.hide();

	} );
	
}



// END OF DOCUMENT
